@if (loadingContent === true) {
<div [@inOutAnimation] class="loader -wrapper"></div>
} @if (loadingContent) {
<div [@inOutAnimation] class="loader -parent">
  <div class="loader -circle"></div>
  <div class="loader -line--mask">
    <div class="loader -line"></div>
  </div>
  <!-- <img src="/assets/images/icon.svg"/> -->
</div>
}
